module.exports = __webpack_public_path__ + "prod/1.42.2/img/Q-fang.bb524735.png";